import { CSATFeedbackState, CSATFeedbackAction } from 'stores/flow-type/csat-feedback.type';

const initialState: CSATFeedbackState = {
  loading: false,
  success: false,
  error: null,
  isShow: false,
  isMultiple: false,
  metadata: null
};

const csatFeedbackReducers = (
  state: CSATFeedbackState = initialState,
  action: CSATFeedbackAction
) => {
  const { type } = action;

  switch (type) {
    default:
      return state;
  }
};

export default csatFeedbackReducers;
